<template>
  <div id="text-box">
    <v-row>
      <v-col cols="10">
        <div id="text-toolbar" class="wrapper">
          <emoji-picker @emoji="append" :search="search">
            <div
              class="emoji-invoker"
              slot="emoji-invoker"
              slot-scope="{ events: { click: clickEvent } }"
              @click.stop="clickEvent"
            >
              <svg
                height="24"
                viewBox="0 0 24 24"
                width="24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 0h24v24H0z" fill="none" />
                <path
                  d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
                />
              </svg>
            </div>
            <div slot="emoji-picker" slot-scope="{ emojis, insert }">
              <div class="emoji-picker" :style="{ bottom: 30 + 'px' }">
                <div class="emoji-picker__search">
                  <input type="text" v-model="search" v-focus />
                </div>
                <div>
                  <div v-for="(emojiGroup, category) in emojis" :key="category">
                    <h5>{{ category }}</h5>
                    <div class="emojis">
                      <span
                        v-for="(emoji, emojiName) in emojiGroup"
                        :key="emojiName"
                        @click="insert(emoji)"
                        :title="emojiName"
                      >
                        {{ emoji }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </emoji-picker>
        </div>

        <VueEditor v-model="input" :editor-toolbar="customToolbar" />
      </v-col>

      <v-col>
        <v-btn
          id="send-button"
          color="primary"
          :disabled="!this.input.length"
          @click="sendMessage()"
        >
          send
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { EmojiPicker } from "vue-emoji-picker";

import { VueEditor, Quill } from "vue2-editor";

export default {
  components: {
    EmojiPicker,

    VueEditor
  },
  data() {
    return {
      input: "",
      search: "",
      theme: "bubble",
      customToolbar: [
        [{ font: [] }, { size: [] }],
        ["bold", "italic", "underline"],
        [{ color: [] }, { background: [] }],
        ["image", "video"],
        ["emoji"]
      ]
    };
  },

  methods: {
    append(emoji) {
      if (this.input.length > 0 && this.input[this.input.length - 2] !== "n") {
        this.input = this.input.split("");
        this.input.splice(
          this.input.length - 4,
          0,
          "<span class='ql-size-huge'>" + emoji + "</span>"
        );
        this.input.splice(this.input.length - 4, 0, " ");
        this.input = this.input.join("");
      } else if (
        this.input.length > 0 &&
        this.input[this.input.length - 2] == "n"
      ) {
        this.input = this.input.split("");
        this.input.splice(
          this.input.length - 7,
          0,
          "<span class='ql-size-huge'>" + emoji + "</span>"
        );
        this.input.splice(this.input.length - 7, 0, " ");
        this.input = this.input.join("");
      } else {
        this.input += "<span class='ql-size-huge'>" + emoji + "</span>";
        this.input = this.input.split("");
        console.log(this.input);
        this.input.splice(this.input.length - 4, 0, " ");
        this.input = this.input.join("");
      }
    },
    sendMessage() {
      this.$emit("sendmessage", this.input);
      this.input = "";
    }
  }
};
</script>

<style lang="css">
@import "~vue2-editor/dist/vue2-editor.css";
@import "~quill/dist/quill.core.css";
@import "~quill/dist/quill.bubble.css";
@import "~quill/dist/quill.snow.css";
.indemoji {
  font-size: 36px;
}
</style>
